export default __webpack_public_path__ + "static/SSSpyView_screenshot-2-704e2a9d69cba8ee3556a72c138811b6.jpg";